import { combineReducers } from 'redux'
import { StateType } from 'typesafe-actions'
import undoable, { excludeAction } from 'redux-undo'
import image from './image'

const rootReducer = combineReducers({
  image: undoable(image, {
    filter: excludeAction([
      'ADD_FILE',
      // 'SET_ACTIVE_IMAHE',
      'SET_COMPARE_INDEX',
      'UPDATE_CROP_SIZE',
      'CHANGE_TEMPLATE_MODE',
      'GET_CUT_IMAGE',
      'GET_PREVIEW_IMAGES',
      'REMOVE_IMAGES',
      'UPDATE_FILE',
      'CLEAR_ALL_FILES',
    ]),
  }),
})

export type RootState = StateType<typeof rootReducer>

export default rootReducer
